import { BrowserRouter } from "react-router-dom";
import { DataStoreContextProvider } from "context/DataStoreContext";
import AuthRouter from "component/core/AuthRouter";

const App: React.FC = () =>
  <DataStoreContextProvider>
    <BrowserRouter basename='/'>
      <AuthRouter />
    </BrowserRouter>
  </DataStoreContextProvider>;

export default App;
